import { t } from 'i18next';

/**
 *  Temporary fix before we unite integration and Skymap's errors into same common/error file.
 */
export type ErrorResponseErrorItemCodeXsite =
  | 'xsite:skymap_project_already_connected'
  | 'xsite:xsite_site_already_connected';

export const translations = (): Record<ErrorResponseErrorItemCodeXsite, string> => ({
  'xsite:skymap_project_already_connected': t('xsite.skymapProjectAlreadyConnected', {
    ns: 'apiErrorCodes',
    defaultValue: 'Projektet är redan integrerat med en annan site i Xsite.',
  }),
  'xsite:xsite_site_already_connected': t('xsite.xsiteSiteAlreadyConnected', {
    ns: 'apiErrorCodes',
    defaultValue: 'Siten är redan integrerad med ett annat projekt i SkyMap.',
  }),
});
